module.exports = __webpack_public_path__ + "img/bx-classroom-timetable.a27c747f.svg";